import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Loader } from 'semantic-ui-react';
import styled from 'styled-components';
import { Redirect, Route, RouteProps } from 'react-router';
import { IUser } from '@relab/alstom-ptw-shared';

import { appState, appStateServerRequests } from '../redux/selectors';
import { ActionType, RootState, ServerRequestStatus } from '../redux/types';
import { checkLoginAction } from '../redux/actions';
import { client } from '../redux/store';
import i18n from 'i18next';
import moment from 'moment';

interface PPrivateRouteProps extends RouteProps {
  checkLoginAction?: typeof checkLoginAction;
  serverRequest?: ServerRequestStatus;
  user?: IUser;
}

const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const LoaderContainerComponent = () => (
  <LoaderContainer>
    <Loader active inline="centered" />
  </LoaderContainer>
);

const PPrivateRoute = ({ checkLoginAction, component, serverRequest, user, ...rest }: PPrivateRouteProps) => {
  useEffect(() => {
    if (user && user.preferredLanguage && i18n.language !== user.preferredLanguage) {
      i18n.changeLanguage(user.preferredLanguage);
      moment.locale(user.preferredLanguage);
    }
  }, [user]);

  const authorization = localStorage.getItem('Authorization');
  if (!!authorization) {
    if (!serverRequest) {
      client.defaults.headers.common['Authorization'] = authorization;
      setTimeout(() => checkLoginAction(), 0);
      return <LoaderContainerComponent />;
    } else {
      if (!serverRequest.pending) {
        return (
          <Route
            {...rest}
            render={(props) =>
              user ? React.createElement(component, props) : <Redirect to={{ pathname: '/signin' }} />
            }
          />
        );
      } else {
        return <LoaderContainerComponent />;
      }
    }
  } else {
    return <Redirect to={{ pathname: '/signin' }} />;
  }
};

const mapStateToProps = (state: RootState) => ({
  serverRequest: appStateServerRequests(state, ActionType.CHECK_LOGIN),
  user: appState(state).user,
});

export const PrivateRoute = connect(mapStateToProps, { checkLoginAction })(PPrivateRoute);
